var _circle, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMailLoom = function SvgMailLoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    fill: "#1874FD",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#MailLoom_svg__a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.937 17.85h-1.011v6.892l-4.43-4.43-.848.85 4.351 4.357H12.073l4.213-4.358-.867-.837-4.345 4.496V14.396l7.481 7.445a1.204 1.204 0 0 0 1.697 0l4.009-3.99h-1.704l-3.153 3.136-7.541-7.505h8.877l.692-1.204H11.074a1.204 1.204 0 0 0-1.204 1.204v12.037a1.204 1.204 0 0 0 1.204 1.203h16.852a1.204 1.204 0 0 0 1.204-1.204v-7.68l-.193.013Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.826 9.269-3.442 5.964a.771.771 0 0 0 .662 1.15h6.891a.77.77 0 0 0 .662-1.15l-3.442-5.964a.77.77 0 0 0-1.33 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "MailLoom_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8.667 8.667)",
    d: "M0 0h21.667v21.667H0z"
  })))));
};

export default SvgMailLoom;